module.exports = __webpack_public_path__ + "59d07d84f3117118bf36a605ae12c796.svg";